import { render, staticRenderFns } from "./ButtonLoginAzureAD.vue?vue&type=template&id=261b81f2&scoped=true"
import script from "./ButtonLoginAzureAD.vue?vue&type=script&lang=js"
export * from "./ButtonLoginAzureAD.vue?vue&type=script&lang=js"
import style0 from "./ButtonLoginAzureAD.vue?vue&type=style&index=0&id=261b81f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261b81f2",
  null
  
)

export default component.exports